<!--
 * @Description: 石模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:05:29
-->
<template>
  <div id="template6" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="9"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.code }}</td>
        <td :class="{ bg5: !isViewResult }"></td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>工程名称</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_03 }}</td>
        <td>取样日期</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>规 格</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>产 地</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_07.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检验依据</td>
        <td :class="{ bg4: !isViewResult }" colspan="2">
          <el-input :v-model="formData.cell_12 ? formData.cell_12.resultValue: 0" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>含泥量（%）</td>
        <td :class="{ bg5: !isViewResult }" colspan="2"><el-input v-model="formData.cell_13.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td>泥块含量（%）</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-select v-model="formData.cell_14.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_14.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>颗粒级配</td>
        <td :class="{ bg5: !isViewResult }">
          <el-select v-model="formData.cell_15.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_15.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>针片状含量（%）</td>
        <td :class="{ bg5: !isViewResult }" colspan="2"><el-input v-model="formData.cell_16.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
      </tr>
      <tr>
        <td rowspan="4">堆积密度</td>
        <td rowspan="2">（样+筒）（g）</td>
        <td rowspan="2">筒重（g）</td>
        <td rowspan="2">筒容积（L）</td>
        <td rowspan="2">密度值（kg/m³）</td>
        <td rowspan="2">平均值（kg/m³）</td>
        <td colspan="6">筛分分析试验</td>
      </tr>
      <tr>
        <td colspan="2">试样重（g）</td>
        <td :class="{ bg3: !isViewResult }" colspan="4">
          <el-input v-model="formData.cell_63.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_17.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_18.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_20.resultValue }}</td>
        <td :class="formData.cell_25.clsObj" rowspan="2">
          {{ formData.cell_25.resultValue }}
          <el-tooltip v-if="formData.cell_25.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_25.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td rowspan="2">筛孔尺寸（mm）</td>
        <td rowspan="2">分计筛余量（g）</td>
        <td rowspan="2" colspan="2">分计筛余百分率（%）</td>
        <td rowspan="2" colspan="2">累计筛余百分率（%）</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_21.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_22.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_23.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_24.resultValue }}</td>
      </tr>
      <tr>
        <td rowspan="4">表观密度</td>
        <td rowspan="2">样重（g）</td>
        <td rowspan="2">（瓶+水）重（g）</td>
        <td rowspan="2">（样+瓶+水）重（g）</td>
        <td rowspan="2">密度值（kg/m³）</td>
        <td rowspan="2">平均值（kg/m³）</td>
        <td>63.00</td>
        <td>
          <el-input :v-model="formData.cell_64 ? formData.cell_64.resultValue: 0" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_65 ? formData.cell_65.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_66 ? formData.cell_66.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td>53.00</td>
        <td>
          <el-input :v-model="formData.cell_67 ? formData.cell_67.resultValue: 0" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_68 ? formData.cell_68.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_69 ? formData.cell_69.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_28.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_29.resultValue }}</td>
        <td :class="formData.cell_34.clsObj" rowspan="2">
          {{ formData.cell_34.resultValue }}
          <el-tooltip v-if="formData.cell_34.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_34.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>37.50</td>
        <td>
          <el-input :v-model="formData.cell_70 ? formData.cell_70.resultValue: 0" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_71 ? formData.cell_71.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_72 ? formData.cell_72.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_30.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_31.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_32.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_33.resultValue }}</td>
        <td>31.50</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_73.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_74 ? formData.cell_74.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_75 ? formData.cell_75.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td>空隙率（%）</td>
        <td colspan="5">{{ formData.cell_35.resultValue }}</td>
        <td>26.50</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_76.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_77 ? formData.cell_77.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_78 ? formData.cell_78.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td rowspan="3">含泥量</td>
        <td>洗前干重（g）</td>
        <td>洗后干重（g）</td>
        <td>含泥量（%）</td>
        <td colspan="2">平均值（%）</td>
        <td>19.00</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_79.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_80 ? formData.cell_80.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_81 ? formData.cell_81.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_36.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_37.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_38.resultValue }}</td>
        <td :class="formData.cell_42.clsObj" colspan="2" rowspan="2">
          {{ formData.cell_42.resultValue }}
          <el-tooltip v-if="formData.cell_42.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_42.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>16.00</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_82.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_83 ? formData.cell_83.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_84 ? formData.cell_84.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_41.resultValue }}</td>
        <td>9.50</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_85.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_86 ? formData.cell_86.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_87 ? formData.cell_87.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td rowspan="3">泥块含量</td>
        <td>洗前干重（g）</td>
        <td>洗后干重（g）</td>
        <td>泥块含量（%）</td>
        <td colspan="2">平均值（%）</td>
        <td>4.75</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_88.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_89 ? formData.cell_89.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_90 ? formData.cell_90.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_43.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_44.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_45.resultValue }}</td>
        <td :class="formData.cell_49.clsObj" colspan="2" rowspan="2">
          {{ formData.cell_49.resultValue }}
          <el-tooltip v-if="formData.cell_49.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_49.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>2.36</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_91.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_92 ? formData.cell_92.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_93 ? formData.cell_93.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_48.resultValue }}</td>
        <td>底</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_94.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">{{ formData.cell_95 ? formData.cell_95.resultValue: 0 }}</td>
        <td colspan="2">{{ formData.cell_96 ? formData.cell_96.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td rowspan="3">针片状颗粒含量</td>
        <td colspan="2" rowspan="2">样重（g）</td>
        <td colspan="2" rowspan="2">（针状+片状）重（g）</td>
        <td rowspan="2">针片状颗粒含量（%）</td>
        <td>最大公称粒径（mm）</td>
        <td colspan="2">
          <el-input v-model="formData.cell_97.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>级配判定</td>
        <td :class="formData.cell_98.clsObj" colspan="2">
          <el-select v-model="formData.cell_98.resultValue" placeholder="请选择">
            <el-option :value="0" label="合格"></el-option>
            <el-option :value="1" label="不合格"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>实测规格（mm）</td>
        <td colspan="2">
          <el-input v-model="formData.cell_99.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_50.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_51.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_52.clsObj">
          {{ formData.cell_52.resultValue }}
          <el-tooltip v-if="formData.cell_52.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_52.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td rowspan="5">备 注</td>
        <td rowspan="5" colspan="5">
          <el-input v-model="formData.cell_100.resultValue" type="textarea" :rows="5" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="4">压碎指标</td>
        <td>样重（g）</td>
        <td>压碎后筛余（g）</td>
        <td>压碎指标（%）</td>
        <td colspan="2">平均值（%）</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_53.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_54.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_55.resultValue }}</td>
        <td :class="formData.cell_62.clsObj" colspan="2" rowspan="3">
          {{ formData.cell_62.resultValue }}
          <el-tooltip v-if="formData.cell_62.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_62.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_56.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_57.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_58.resultValue }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_59.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_60.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_61.resultValue }}</td>
      </tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_07: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_07" },
  cell_08: { resultValue: "", key: "syrq", title: "实验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_11" },
  cell_12: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_63: { resultValue: "", key: "sfsyz", title: "筛分试样重", category: 6, type: 3, code: "cell_63" },

  cell_13: { key: "kjhnl", title: "含泥量", category: 7, type: 2, resultValue: "", verify: "请配置含泥量" },
  cell_14: {
    key: "kjnkhl",
    title: "泥块含量",
    category: 7,
    type: 1,
    resultValue: "",
    verify: "请配置泥块含量",
    options: [
      { id: 0, label: "目测无" },
      { id: 1, label: "目测有" },
    ],
  },
  cell_15: {
    key: "kjkljp",
    title: "颗粒级配",
    category: 7,
    type: 1,
    resultValue: "",
    verify: "请配置颗粒级配",
    options: [
      { id: 0, label: "合格" },
      { id: 1, label: "不合格" },
    ],
  },
  cell_16: { key: "zpzhl", title: "针片状含量（%）", category: 7, type: 2, resultValue: "", verify: "请配置含泥量" },

  cell_17: { resultValue: "", key: "djmdyt1", title: "堆积密度（样+筒）", category: 6, type: 3, code: "cell_17" },
  cell_18: { resultValue: "", key: "djmdtz1", title: "堆积密度（筒重）", category: 6, type: 3, code: "cell_18" },
  cell_19: { resultValue: "", key: "djmdtrj1", title: "堆积密度（筒容积）", category: 6, type: 3, code: "cell_19" },
  cell_21: { resultValue: "", key: "djmdyt2", title: "堆积密度（样+筒）", category: 6, type: 3, code: "cell_21" },
  cell_22: { resultValue: "", key: "djmdtz2", title: "堆积密度（筒重）", category: 6, type: 3, code: "cell_22" },
  cell_23: { resultValue: "", key: "djmdtrj2", title: "堆积密度（筒容积）", category: 6, type: 3, code: "cell_23" },

  cell_26: { resultValue: "", key: "bgmdyz1", title: "表观密度（样重）", category: 6, type: 3, code: "cell_26" },
  cell_27: { resultValue: "", key: "bgmdps1", title: "表观密度（瓶+水）", category: 6, type: 3, code: "cell_27" },
  cell_28: { resultValue: "", key: "bgmdyps1", title: "表观密度（样+瓶+水）", category: 6, type: 3, code: "cell_28" },
  cell_30: { resultValue: "", key: "bgmdyz2", title: "表观密度（样重）", category: 6, type: 3, code: "cell_30" },
  cell_31: { resultValue: "", key: "bgmdps2", title: "表观密度（瓶+水）", category: 6, type: 3, code: "cell_31" },
  cell_32: { resultValue: "", key: "bgmdyps2", title: "表观密度（样+瓶+水）", category: 6, type: 3, code: "cell_32" },

  cell_36: { resultValue: "", key: "hnlxqgz1", title: "含泥量（洗前干重）", category: 6, type: 3, code: "cell_36" },
  cell_37: { resultValue: "", key: "hnlxhgz1", title: "含泥量（洗后干重）", category: 6, type: 3, code: "cell_37" },
  cell_39: { resultValue: "", key: "hnlxqgz2", title: "含泥量（洗前干重）", category: 6, type: 3, code: "cell_39" },
  cell_40: { resultValue: "", key: "hnlxhgz2", title: "含泥量（洗后干重）", category: 6, type: 3, code: "cell_40" },

  cell_43: { resultValue: "", key: "nkhlxqgz1", title: "泥块含量（洗前干重）", category: 6, type: 3, code: "cell_43" },
  cell_44: { resultValue: "", key: "nkhlxhgz1", title: "泥块含量（洗后干重）", category: 6, type: 3, code: "cell_44" },
  cell_46: { resultValue: "", key: "nkhlxqgz2", title: "泥块含量（洗前干重）", category: 6, type: 3, code: "cell_46" },
  cell_47: { resultValue: "", key: "nkhlxhgz2", title: "泥块含量（洗后干重）", category: 6, type: 3, code: "cell_47" },

  cell_50: { resultValue: "", key: "zpzklhl1", title: "针片状颗粒含量（样重）", category: 6, type: 3, code: "cell_50" },
  cell_51: { resultValue: "", key: "zpzklhl2", title: "（针状+片状）重", category: 6, type: 3, code: "cell_51" },

  cell_97: { resultValue: "", key: "zdgclj", title: "最大公称粒径", category: 6, type: 3, code: "cell_97" },
  cell_98: { resultValue: "", key: "jppd", title: "级配判定", category: 6, type: 3, code: "cell_98", clsObj: { bg1: true } },
  cell_99: { resultValue: "", key: "scgg", title: "实测规格", category: 6, type: 3, code: "cell_99" },
  // cell_99: {
  //   resultValue: "",
  //   key: "scgg",
  //   title: "实测规格",
  //   category: 1,
  //   type: 1,
  //   code: "cell_99",
  //   options: [
  //     { value: 0, label: "合格" },
  //     { value: 1, label: "不合格" },
  //   ],
  // },

  cell_53: { resultValue: "", key: "yszbyz1", title: "压碎指标样重", category: 6, type: 3, code: "cell_53" },
  cell_54: { resultValue: "", key: "yshsy1", title: "压碎后筛余", category: 6, type: 3, code: "cell_54" },
  cell_56: { resultValue: "", key: "yszbyz2", title: "压碎指标样重", category: 6, type: 3, code: "cell_56" },
  cell_57: { resultValue: "", key: "yshsy2", title: "压碎后筛余", category: 6, type: 3, code: "cell_57" },
  cell_59: { resultValue: "", key: "yszbyz3", title: "压碎指标样重", category: 6, type: 3, code: "cell_59" },
  cell_60: { resultValue: "", key: "yshsy3", title: "压碎后筛余", category: 6, type: 3, code: "cell_60" },

  cell_64: { resultValue: "", key: "fjsyl1", title: "分计筛余量", category: 6, type: 3, code: "cell_64" },
  cell_67: { resultValue: "", key: "fjsyl2", title: "分计筛余量", category: 6, type: 3, code: "cell_67" },
  cell_70: { resultValue: "", key: "fjsyl3", title: "分计筛余量", category: 6, type: 3, code: "cell_70" },
  cell_73: { resultValue: "", key: "fjsyl4", title: "分计筛余量", category: 6, type: 3, code: "cell_73" },
  cell_76: { resultValue: "", key: "fjsyl5", title: "分计筛余量", category: 6, type: 3, code: "cell_76" },
  cell_79: { resultValue: "", key: "fjsyl6", title: "分计筛余量", category: 6, type: 3, code: "cell_79" },
  cell_82: { resultValue: "", key: "fjsyl7", title: "分计筛余量", category: 6, type: 3, code: "cell_82" },
  cell_85: { resultValue: "", key: "fjsyl8", title: "分计筛余量", category: 6, type: 3, code: "cell_85" },
  cell_88: { resultValue: "", key: "fjsyl9", title: "分计筛余量", category: 6, type: 3, code: "cell_88" },
  cell_91: { resultValue: "", key: "fjsyl10", title: "分计筛余量", category: 6, type: 3, code: "cell_91" },
  cell_94: { resultValue: "", key: "fjsyl11", title: "分计筛余量", category: 6, type: 3, code: "cell_94" },

  cell_100: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_100" },

  // 以下为计算属性
  cell_20: { resultValue: "", key: "djmd1", title: "堆积密度值", category: 6, type: 3, code: "cell_20" },
  cell_24: { resultValue: "", key: "djmd2", title: "堆积密度值", category: 6, type: 3, code: "cell_24" },
  cell_25: { resultValue: "", key: "djmd", title: "堆积密度平均值", category: 1, type: 3, code: "cell_25", clsObj: { bg1: true } },
  cell_29: { resultValue: "", key: "bgmd1", title: "表观密度值", category: 6, type: 3, code: "cell_29" },
  cell_33: { resultValue: "", key: "bgmd2", title: "表观密度值", category: 6, type: 3, code: "cell_33" },
  cell_34: { resultValue: "", key: "bgmd", title: "表观密度平均值", category: 1, type: 3, code: "cell_34", clsObj: { bg1: true } },
  cell_35: { resultValue: "", key: "kxl", title: "孔隙率", category: 6, type: 3, code: "cell_35" },
  cell_38: { resultValue: "", key: "hnl1", title: "含泥量", category: 6, type: 3, code: "cell_38" },
  cell_41: { resultValue: "", key: "hnl2", title: "含泥量", category: 6, type: 3, code: "cell_41" },
  cell_42: { resultValue: "", key: "hnl", title: "含泥量平均值", category: 1, type: 3, code: "cell_42", clsObj: { bg1: true } },
  cell_45: { resultValue: "", key: "nkhl1", title: "泥块含量", category: 6, type: 3, code: "cell_45" },
  cell_48: { resultValue: "", key: "nkhl2", title: "泥块含量", category: 6, type: 3, code: "cell_48" },
  cell_49: { resultValue: "", key: "nkhl", title: "泥块含量平均值", category: 1, type: 3, code: "cell_49", clsObj: { bg1: true } },
  cell_52: { resultValue: "", key: "zpzklhl", title: "针片状颗粒含量", category: 1, type: 3, code: "cell_52", clsObj: { bg1: true } },
  cell_55: { resultValue: "", key: "yszb1", title: "压碎指标", category: 6, type: 3, code: "cell_55" },
  cell_58: { resultValue: "", key: "yszb2", title: "压碎指标", category: 6, type: 3, code: "cell_58" },
  cell_61: { resultValue: "", key: "yszb3", title: "压碎指标", category: 6, type: 3, code: "cell_61" },
  cell_62: { resultValue: "", key: "yszb", title: "压碎指标", category: 1, type: 3, code: "cell_62", clsObj: { bg1: true } },
  cell_65: { resultValue: "", key: "fjsybfl1", title: "分计筛余百分率", category: 6, type: 3, code: "cell_65" },
  cell_68: { resultValue: "", key: "fjsybfl2", title: "分计筛余百分率", category: 6, type: 3, code: "cell_68" },
  cell_71: { resultValue: "", key: "fjsybfl3", title: "分计筛余百分率", category: 6, type: 3, code: "cell_71" },
  cell_74: { resultValue: "", key: "fjsybfl4", title: "分计筛余百分率", category: 6, type: 3, code: "cell_74" },
  cell_77: { resultValue: "", key: "fjsybfl5", title: "分计筛余百分率", category: 6, type: 3, code: "cell_77" },
  cell_80: { resultValue: "", key: "fjsybfl6", title: "分计筛余百分率", category: 6, type: 3, code: "cell_80" },
  cell_83: { resultValue: "", key: "fjsybfl7", title: "分计筛余百分率", category: 6, type: 3, code: "cell_83" },
  cell_86: { resultValue: "", key: "fjsybfl8", title: "分计筛余百分率", category: 6, type: 3, code: "cell_86" },
  cell_89: { resultValue: "", key: "fjsybfl9", title: "分计筛余百分率", category: 6, type: 3, code: "cell_89" },
  cell_92: { resultValue: "", key: "fjsybfl10", title: "分计筛余百分率", category: 6, type: 3, code: "cell_92" },
  cell_95: { resultValue: "", key: "fjsybfl11", title: "分计筛余百分率", category: 6, type: 3, code: "cell_95" },
  cell_66: { resultValue: "", key: "ljsybfl1", title: "分计筛余百分率", category: 6, type: 3, code: "cell_66" },
  cell_69: { resultValue: "", key: "ljsybfl2", title: "分计筛余百分率", category: 6, type: 3, code: "cell_69" },
  cell_72: { resultValue: "", key: "ljsybfl3", title: "分计筛余百分率", category: 6, type: 3, code: "cell_72" },
  cell_75: { resultValue: "", key: "ljsybfl4", title: "分计筛余百分率", category: 6, type: 3, code: "cell_75" },
  cell_78: { resultValue: "", key: "ljsybfl5", title: "分计筛余百分率", category: 6, type: 3, code: "cell_78" },
  cell_81: { resultValue: "", key: "ljsybfl6", title: "分计筛余百分率", category: 6, type: 3, code: "cell_81" },
  cell_84: { resultValue: "", key: "ljsybfl7", title: "分计筛余百分率", category: 6, type: 3, code: "cell_84" },
  cell_87: { resultValue: "", key: "ljsybfl8", title: "分计筛余百分率", category: 6, type: 3, code: "cell_87" },
  cell_90: { resultValue: "", key: "ljsybfl9", title: "分计筛余百分率", category: 6, type: 3, code: "cell_90" },
  cell_93: { resultValue: "", key: "ljsybfl10", title: "分计筛余百分率", category: 6, type: 3, code: "cell_93" },
  cell_96: { resultValue: "", key: "ljsybfl11", title: "分计筛余百分率", category: 6, type: 3, code: "cell_96" },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
  },
  mounted() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (!item) {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    this.$set(this.formData, "cell_99", dataArr["cell_99"]);
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    roundOffMethod(value, modulus) {
      return Math.round(value / modulus) * modulus;
    },
    getChanges() {
      // 有输入就核算
      let val = "";
      // 第一次松散堆积密度
      if (this.hasValues([17, 18, 19])) {
        val = this.roundOffMethod((this.getFieldVal(17) - this.getFieldVal(18)) / this.getFieldVal(19), 10);
      }
      this.setFieldVal(20, val);
      val = "";
      // 第二次松散堆积密度
      if (this.hasValues([21, 22, 23])) {
        val = this.roundOffMethod((this.getFieldVal(21) - this.getFieldVal(22)) / this.getFieldVal(23), 10);
      }
      this.setFieldVal(24, val);
      val = "";
      // 松散堆积密度
      if (this.hasValues([20, 24])) {
        val = this.roundOffMethod((this.getFieldVal(20) + this.getFieldVal(24)) / 2, 10);
      }
      this.setFieldVal(25, val);
      val = "";
      // 第一次表观密度
      if (this.hasValues([26, 27, 28])) {
        const divisor = this.getFieldVal(26) + this.getFieldVal(27) - this.getFieldVal(28);
        if (divisor !== 0) {
          val = this.roundOffMethod((this.getFieldVal(26) / divisor) * 1000, 10);
        }
      }
      this.setFieldVal(29, val);
      val = "";
      // 第二次表观密度
      if (this.hasValues([30, 31, 32])) {
        const divisor = this.getFieldVal(30) + this.getFieldVal(31) - this.getFieldVal(32);
        if (divisor !== 0) {
          val = this.roundOffMethod((this.getFieldVal(30) / divisor) * 1000, 10);
        }
      }
      this.setFieldVal(33, val);
      val = "";
      // 表观密度
      if (this.hasValues([29, 33])) {
        let modulus = 0;
        if (Math.abs(this.getFieldVal(29) - this.getFieldVal(33)) <= 20) {
          modulus = (this.getFieldVal(29) + this.getFieldVal(33)) / 2;
        }
        val = this.roundOffMethod(modulus, 10);
      }
      this.setFieldVal(34, val);
      val = "";
      // 孔隙率
      if (this.hasValues([25, 34])) {
        val = (1 - this.getFieldVal(25) / this.getFieldVal(34)) * 100;
      }
      this.setFieldVal(35, val);
      val = "";
      // 含泥量1
      if (this.hasValues([36, 37])) {
        val = (((this.getFieldVal(36) - this.getFieldVal(37)) / this.getFieldVal(36)) * 100).toFixed(1);
      }
      this.setFieldVal(38, val);
      val = "";
      // 含泥量2
      if (this.hasValues([39, 40])) {
        val = (((this.getFieldVal(39) - this.getFieldVal(40)) / this.getFieldVal(39)) * 100).toFixed(1);
      }
      this.setFieldVal(41, val);
      val = "";
      // 含泥量
      if (this.hasValues([38, 41])) {
        val = ((this.getFieldVal(38) + this.getFieldVal(41)) / 2).toFixed(1);
      }
      this.setFieldVal(42, val);
      val = "";
      // 泥块含量1
      if (this.hasValues([43, 44])) {
        val = (((this.getFieldVal(43) - this.getFieldVal(44)) / this.getFieldVal(43)) * 100).toFixed(1);
      }
      this.setFieldVal(45, val);
      val = "";
      // 泥块含量2
      if (this.hasValues([46, 47])) {
        val = (((this.getFieldVal(46) - this.getFieldVal(47)) / this.getFieldVal(46)) * 100).toFixed(1);
      }
      this.setFieldVal(48, val);
      val = "";
      // 泥块含量
      if (this.hasValues([45, 48])) {
        val = ((this.getFieldVal(45) + this.getFieldVal(48)) / 2).toFixed(1);
      }
      this.setFieldVal(49, val);
      val = "";
      // 针片状含量
      if (this.hasValues([50, 51])) {
        val = ((this.getFieldVal(51) / this.getFieldVal(50)) * 100).toFixed(1);
      }
      this.setFieldVal(52, val);
      val = "";
      // 压碎指标1
      if (this.hasValues([53, 54])) {
        val = (((this.getFieldVal(53) - this.getFieldVal(54)) / this.getFieldVal(53)) * 100).toFixed(1);
      }
      this.setFieldVal(55, val);
      val = "";
      // 压碎指标2
      if (this.hasValues([56, 57])) {
        val = (((this.getFieldVal(56) - this.getFieldVal(57)) / this.getFieldVal(56)) * 100).toFixed(1);
      }
      this.setFieldVal(58, val);
      val = "";
      // 压碎指标3
      if (this.hasValues([59, 60])) {
        val = (((this.getFieldVal(59) - this.getFieldVal(60)) / this.getFieldVal(59)) * 100).toFixed(1);
      }
      this.setFieldVal(61, val);
      val = "";
      // 压碎指标
      if (this.hasValues([55, 58, 61])) {
        val = ((this.getFieldVal(55) + this.getFieldVal(58) + this.getFieldVal(61)) / 3).toFixed(1);
      }
      this.setFieldVal(62, val);

      // 筛分分析试验
      if (this.hasValues([63])) {
        val = "";
        if (this.hasValues([73])) {
          val = ((this.getFieldVal(73) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(74, val);
        val = "";
        if (this.hasValues([76])) {
          val = ((this.getFieldVal(76) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(77, val);
        val = "";
        if (this.hasValues([79])) {
          val = ((this.getFieldVal(79) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(80, val);
        val = "";
        if (this.hasValues([82])) {
          val = ((this.getFieldVal(82) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(83, val);
        val = "";
        if (this.hasValues([85])) {
          val = ((this.getFieldVal(85) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(86, val);
        val = "";
        if (this.hasValues([88])) {
          val = ((this.getFieldVal(88) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(89, val);
        val = "";
        if (this.hasValues([91])) {
          val = ((this.getFieldVal(91) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(92, val);
        val = "";
        if (this.hasValues([94])) {
          val = ((this.getFieldVal(94) / this.getFieldVal(63)) * 100).toFixed(1);
        }
        this.setFieldVal(95, val);
      }
      //递归求和
      this.recursionSum([74], 75);
      this.recursionSum([75, 77], 78);
      this.recursionSum([78, 80], 81);
      this.recursionSum([81, 83], 84);
      this.recursionSum([84, 86], 87);
      this.recursionSum([87, 89], 90);
      this.recursionSum([90, 92], 93);
      this.recursionSum([93, 95], 96);
      //级配判定
      if (this.hasValues([99])) {
        val = this.gradingDecision();
        this.setFieldVal(98, val ? "合格" : "不合格");
      }
    },
    //递归求和
    recursionSum(arr, target) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        // res = sum.toFixed(1)
        res = Math.round(sum);
      }
      this.setFieldVal(target, res);
    },
    //级配判定
    gradingDecision() {
      const num = this.getFieldVal(99);
      const data = {
        31.5: this.getFieldVal(75),
        26.5: this.getFieldVal(78),
        19: this.getFieldVal(81),
        16: this.getFieldVal(84),
        9.5: this.getFieldVal(87),
        4.75: this.getFieldVal(90),
        2.36: this.getFieldVal(93),
      };
      const checkScope = (value, max, min) => value <= max && value >= min;
      if (num >= 5 && num <= 10) {
        return checkScope(data["2.36"], 100, 95) && checkScope(data["4.75"], 100, 80) && checkScope(data["9.5"], 15, 0) && checkScope(data["16"], 0, 0);
      } else if (num >= 5 && num <= 16) {
        return checkScope(data["2.36"], 100, 95) && checkScope(data["4.75"], 100, 85) && checkScope(data["9.5"], 60, 30) && checkScope(data["16"], 10, 0) && checkScope(data["19"], 0, 0);
      } else if (num >= 5 && num <= 20) {
        return checkScope(data["2.36"], 100, 95) && checkScope(data["4.75"], 100, 90) && checkScope(data["9.5"], 80, 40) && checkScope(data["19"], 10, 0) && checkScope(data["26.5"], 0, 0);
      } else if (num >= 5 && num <= 25) {
        return checkScope(data["2.36"], 100, 95) && checkScope(data["4.75"], 100, 90) && checkScope(data["16"], 70, 30) && checkScope(data["26.5"], 5, 0) && checkScope(data["31.5"], 0, 0);
      } else if (num >= 5 && num <= 31.5) {
        return checkScope(data["2.36"], 100, 95) && checkScope(data["4.75"], 100, 90) && checkScope(data["9.5"], 90, 70) && checkScope(data["19"], 45, 15) && checkScope(data["31.5"], 5, 0);
      } else if (num >= 5 && num <= 40) {
        return checkScope(data["4.75"], 100, 95) && checkScope(data["9.5"], 90, 70) && checkScope(data["19"], 65, 30);
      } else if (num >= 10 && num <= 20) {
        return checkScope(data["4.75"], 100, 95) && checkScope(data["9.5"], 100, 85) && checkScope(data["19"], 15, 0) && checkScope(data["26.5"], 0, 0);
      } else if (num >= 16 && num <= 31.5) {
        return checkScope(data["4.75"], 100, 95) && checkScope(data["16"], 100, 85) && checkScope(data["31.5"], 10, 0);
      } else if (num >= 20 && num <= 40) {
        return checkScope(data["9.5"], 100, 95) && checkScope(data["19"], 100, 80);
      } else if (num >= 31.5 && num <= 63) {
        return checkScope(data["16"], 100, 95) && checkScope(data["31.5"], 100, 75);
      } else if (num >= 40 && num <= 80) {
        return checkScope(data["19"], 100, 95);
      }
      return false;
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_32_":
          if (this.hasValues(form, ["32_p01", "32_p02", "32_p03"])) {
            res = (((this.getFieldVal("32_p03", false, form) - this.getFieldVal("32_p01", false, form)) / this.getFieldVal("32_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("32_p04", res);
          this.setFieldVal(32, res);
          break;
        case "cell_33_":
          if (this.hasValues(form, ["33_p01", "33_p02", "33_p03"])) {
            res = (((this.getFieldVal("33_p01", false, form) + this.getFieldVal("33_p02", false, form) - this.getFieldVal("33_p03", false, form)) / this.getFieldVal("33_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("33_p04", res);
          this.setFieldVal(33, res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
